/*
 * Created on Mon Jun 28 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import { useEffect, useState, useReducer } from 'react';
import { useFormContext } from "react-hook-form";
import { useWindowDimensions } from './utils/helpers';
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import greyX from "./assets/images/icons/grey-close.png";
import grey82X from "./assets/images/icons/grey828282-close.png";
import darkGreyX from "./assets/images/icons/dark-grey-close.png";
import whiteX from "./assets/images/icons/white-close.png";
import pinkX from "./assets/images/icons/pink-close.png";
import parse from 'html-react-parser';

export function ErrorMsg({ name, className, hide }) {
    const { formState: { errors } } = useFormContext();

    return (
        <span className={"error-msg pink-text " + (className ? className : "")}>{hide ? null : errors[name]?.message}</span>
    )
}

export function ErrorPopup({ whiteText, condition, message }) {
    return (
        <div className={"form-group error-popup " + (condition ? "display" : "")}>
            <span className={"error-msg " + (!whiteText ? "pink-text" : "white-text")}>
                {condition ? parse(message) : null}
            </span>
        </div>
    )
}

let tempEmptyFields = [];

export function Input({ label, name, className, placeholder }) {
    const { register, formState: { errors } } = useFormContext();

    const [emptyFields, setEmptyFields] = useState([]);
    const [hovered, setHovered] = useState(false);
    const [focused, setFocused] = useState(false);

    const addEmptyFieldStyle = fieldName => {
        if (fieldName === 'email') {
            return emptyFields.includes(fieldName) ? 'empty-field' : '';
        }
        return emptyFields.includes(fieldName) ? 'empty-field' : '';
    };

    useEffect(() => {
        setEmptyFields(tempEmptyFields);
        // eslint-disable-next-line
    }, [tempEmptyFields])

    return (
        <>
            {label ?
                <div
                    className={`
                        form-group password
                        ${hovered ? "hovered" : ""} 
                        ${errors[name] ? addEmptyFieldStyle(name) : ""}
                    `}
                    style={{ background: focused ? 'none' : null }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    <label
                        htmlFor={name}
                        className="pink-text input-label"
                        style={{ borderWidth: focused ? '2px' : null }}
                    >
                        {label}
                    </label>
                    <input
                        id={name}
                        type={name.includes('email') ? 'email' : 'text'}
                        className={className}
                        placeholder={placeholder}
                        autoComplete="firstName"
                        {...register(name)}
                        onBlur={() => setFocused(false)}
                        onFocus={() => {
                            setFocused(true);
                            setHovered(false)
                        }}
                        style={{ width: '100%' }}
                    />
                </div>

                :

                <div className="form-group">
                    <input
                        type={name.includes('email') ? 'email' : 'text'}
                        className={`${className} ${errors[name] ? addEmptyFieldStyle(name) : ''}`}
                        placeholder={placeholder}
                        autoComplete="firstName"
                        {...register(name)}
                    />
                </div>
            }
        </>
    )
}

export function PasswordInput({ label, className, name, leaveErrors, showAllPinkBackground }) {
    const { register, setValue, clearErrors, formState: { errors } } = useFormContext();
    const [emptyFields, setEmptyFields] = useState([]);
    const [showIcon, setShowIcon] = useState(false);
    const [hovered, sethovered] = useState(false);
    const [focused, setfocused] = useState(false);
    const [showPassword, togglePassword] = useReducer(
        showPassword => !showPassword,
        false
    );

    const password = register(name || "password");

    const addEmptyFieldStyle = fieldName => {
        return emptyFields.includes(fieldName) || showAllPinkBackground ? 'empty-field' : '';
    };
    // eslint-disable-next-line
    const onInputBlur = (e) => {
        if (e.target.value) {
            setValue(e.target.name, e.target.value, { shouldValidate: true })
        }
        else {
            if (emptyFields.length === 0 && !leaveErrors) {
                clearErrors(e.target.name);
                setValue(e.target.name, e.target.value);
            }
            if (leaveErrors) {
                setValue(e.target.name, e.target.value);
            }
        }
    }
    useEffect(() => {
        setEmptyFields(tempEmptyFields);
        // eslint-disable-next-line
    }, [tempEmptyFields])

    return (
        <div
            className={`
                    form-group password mb-0
                    ${hovered ? "hovered" : ""} 
                    ${errors.password || errors[name] ? addEmptyFieldStyle(name || 'password') : ""}
                `}
            style={{ background: focused ? 'none' : null }}
            onMouseEnter={() => sethovered(true)}
            onMouseLeave={() => sethovered(false)}
        >
            {label ?
                <label
                    htmlFor={name || "password"}
                    className="pink-text input-label"
                    style={{ borderWidth: focused ? '2px' : null }}
                >
                    {label}
                </label>
                : null}
            <input
                id={name || "password"}
                type={showPassword ? 'text' : 'password'}
                className={"form-control " + (className ? className : "")}
                placeholder={label ? null : "Password"}
                autoComplete="off"
                name={password.name}
                ref={password.ref}
                onBlur={(e) => {
                    password.onBlur(e);
                    setfocused(false);
                    // onInputBlur(e)
                }}
                onFocus={() => {
                    setfocused(true);
                    sethovered(false)
                }}
                onChange={(e) => {
                    password.onChange(e);
                    setShowIcon(true);
                    // if ((errors[name] && !errors[name]?.message.includes('Required')) || (errors.password && !errors.password?.message.includes('Required')))
                    //     onInputBlur(e)
                }}
            // {...register(name || "password")}

            />
            {label ? null : <span className="password-border" style={{ borderWidth: focused ? '2px' : null }}></span>}
            <span className="password-icon" onMouseEnter={() => sethovered(false)} onMouseLeave={() => sethovered(true)}>
                <IoMdEye className={showPassword || !showIcon ? 'd-none' : 'float-right'} onClick={togglePassword} />
                <IoMdEyeOff className={showPassword ? 'float-right' : 'd-none'} onClick={togglePassword} />
            </span>
        </div>

    )
}

export function Textarea({ label, name, formGroupClassName, labelClassName, textareaClassName, placeholder, disabled }) {
    const { register, formState: { errors } } = useFormContext();

    const [emptyFields, setEmptyFields] = useState([]);
    const [hovered, setHovered] = useState(false);
    const [focused, setFocused] = useState(false);

    const addEmptyFieldStyle = fieldName => {
        return emptyFields.includes(fieldName) ? 'empty-field' : '';
    };

    useEffect(() => {
        setEmptyFields(tempEmptyFields);
        // eslint-disable-next-line
    }, [tempEmptyFields])

    return (
        <>
            {label ?
                <div
                    className={`
                        form-group password
                        ${formGroupClassName}
                        ${hovered ? "hovered" : ""} 
                        ${errors[name] ? addEmptyFieldStyle(name) : ""}
                    `}
                    style={{ background: focused ? 'none' : null }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    <label
                        htmlFor={name}
                        className={"pink-text " + labelClassName}
                        style={{ borderWidth: focused ? '2px' : null }}
                    >
                        {label}
                    </label>
                    <textarea
                        rows="6"
                        id={name}
                        className={"form-control " + textareaClassName}
                        autoComplete="firstName"
                        {...register(name)}
                        onBlur={() => setFocused(false)}
                        onFocus={() => {
                            setFocused(true);
                            setHovered(false)
                        }}
                        disabled={disabled}
                    />
                </div>

                :

                <div className="form-group">
                    <textarea
                        rows="6"
                        id={name}
                        className={`${textareaClassName} ${errors[name] ? addEmptyFieldStyle(name) : ''}`}
                        placeholder={placeholder}
                        autoComplete="firstName"
                        {...register(name)}
                        disabled={disabled}
                    />
                </div>
            }
        </>
    )
}

export function FormButtons({ opacity, className, disabled, reset, submit, formData, preloader, style }) {
    const initialStyle = { opacity: opacity };
    const addStyles = style ? style : null;
    const mergedStyles = { ...initialStyle, ...addStyles };

    return (
        <div className={"footer-buttons-div fixed-bottom " + (className ? className : "")} style={mergedStyles}>
            <button type="button" className="footer-buttons float-left pink-text reset" disabled={disabled} onClick={reset}>Reset</button>
            <button type="submit" className="footer-buttons float-right pink-text confirm" disabled={disabled} onClick={submit}>
                {preloader ?
                    <>
                        <span className={formData.length !== 0 ? 'd-none' : ''}>Confirm</span>
                        <img className={formData.length !== 0 ? '' : 'd-none'} src={preloader} alt="preloader" />
                    </>
                    :
                    <> Confirm </>
                }
            </button>
        </div>
    )
}

export function SignupBgOne({ desktop, mobile }) {
    const { windowWidth, isMobile } = useWindowDimensions();
    return (
        <img
            id="faBackground"
            className="signup-bg mobile"
            src={windowWidth > 1030 ? desktop : mobile}
            style={isMobile ?
                {
                    width: windowWidth,
                    height: 'auto',
                    minHeight: window.innerHeight
                }
                : null
            }
            alt="background"
        />
    )
}

export const addEmptyFields = (errors) => {
    let array = [];
    for (let [key, value] of Object.entries(errors)) {
        console.log(key, value)
        if (value.type === 'required') {
            array.push(key);
        }
    }
    tempEmptyFields = array;
}

export const clearEmptyFields = () => {
    tempEmptyFields = [];
}

export function CloseButton({ addClass, closeModal, passOpacity, darkGrey }) {
    const [closeIconIndex, setCloseIconIndex] = useState(1);

    const changeIcon = index => {
        return closeIconIndex === index ? 'display' : '';
    }
    return (
        <button
            className={"close-icon " + (addClass ? addClass : '')}
            onMouseEnter={() => {
                setCloseIconIndex(2);
                passOpacity(.5)
            }}
            onMouseLeave={() => {
                setCloseIconIndex(1);
                passOpacity(1);
            }}
            onClick={closeModal}
        >
            <img className={changeIcon(1)}
                onMouseEnter={() => {
                    setCloseIconIndex(2);
                    passOpacity(.5);
                }}
                onMouseLeave={() => {
                    setCloseIconIndex(1);
                    passOpacity(.5);
                }}
                src={darkGrey ? grey82X : greyX}
                alt="close icon"
            />
            <img className={changeIcon(2)}
                onMouseEnter={() => {
                    setCloseIconIndex(3);
                    passOpacity(.5);
                }}
                onMouseLeave={() => {
                    setCloseIconIndex(2);
                    passOpacity(.5);
                }}
                src={darkGrey ? darkGreyX : whiteX}
                alt="close icon"
            />
            <img
                className={changeIcon(3)}
                src={pinkX}
                alt="close icon"
            />
        </button>
    )
}

export function PlayButton({ link }) {
    return (
        <a target="_blank" href={link} rel="noopener noreferrer" >
            <button name="play"></button>
        </a>
    )
}

export function ConditionalWrapper({ condition, wrapper, children }) {
    return condition ? wrapper(children) : children;
}